import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const FiltersSkeleton = () => (
  <Styles.Container>
    <Skeleton variant="rounded" width={250} height={40} />
    <Skeleton variant="rounded" width={120} height={40} />
    <Skeleton variant="rounded" width={130} height={40} />
  </Styles.Container>
)

export default FiltersSkeleton
